"use client";
import React from "react";
import classNames from "classnames";

import SingleSelect from "app/(new-pages)/components/allSelect/baseSelect/pc/SingleSelect";
// import Web3JobFunctionSelectPc from "app/(new-pages)/components/allSelect/Web3JobFunctionSelect/pc";
import LocationSelectPc from "app/(new-pages)/components/allSelect/LocationSelect/pc";

import styles from "../../../style/index.module.scss";
import LanguageSelectPc from "app/(new-pages)/components/allSelect/LanguageSelect/pc";
import { ClearAllIcon } from "../assets/icon";
import OverrideSwitch from "app/(new-pages)/components/overrideAntd/OverrideSwitch";
import JobFunctionSelectPc from "app/(new-pages)/components/allSelect/JobFunctionSelect/pc";

const FiltersInHeader = ({
  config,
  sortFilter,
  locationValue,
  setLocationValue,
  jobFunction,
  setJobFunction,
  language,
  setLanguage,
  isRemote,
  setIsRemote,
  handleClearAll,
  sort,
  setSort,
  handleSortReset,
  rooterStyles
}) => {
  const {
    main_function_filter,
    language_filter,
    location_filter,
    sorted_by_text,
    location_text,
    main_function_text,
    language_text,
    clear_all_text,
    remote_only_text,
    clear_text,
    search_country_text,
    search_job_function_text,
    apply_filters_text
  } = config;

  return (
    <div style={rooterStyles} className={classNames(styles.filterContainer, "yolo-filter-warp")}>
      <div className={styles.fields}>
        <div className={styles.single}>
          <div className={styles.singleField}>
            <SingleSelect
              options={sortFilter}
              variant='borderless'
              value={sort}
              onChange={setSort}
              onReset={handleSortReset}
              clear_text={clear_text}
              showReset={false}
            />
          </div>
        </div>

        <div className={styles.multiple}>
          <div className={styles.field}>
            <LocationSelectPc
              label={location_text}
              location_filter={location_filter}
              value={locationValue}
              onChange={setLocationValue}
              //
              searchBoardPlaceholder={search_country_text}
              boardClearText={clear_text}
              boardApplyFiltersText={apply_filters_text}
            />
          </div>

          <div className={styles.field}>
            <JobFunctionSelectPc
              label={main_function_text}
              main_function_filter={main_function_filter}
              value={jobFunction}
              onChange={setJobFunction}
              //
              searchBoardPlaceholder={search_job_function_text}
              boardClearText={clear_text}
              boardApplyFiltersText={apply_filters_text}
            />
          </div>

          <div className={styles.field}>
            <LanguageSelectPc
              label={language_text}
              language_filter={language_filter}
              value={language}
              onChange={setLanguage}
              //
              boardClearText={clear_text}
              boardApplyFiltersText={apply_filters_text}
            />
          </div>

          <div className={styles.switch}>
            <OverrideSwitch checked={isRemote} onChange={setIsRemote} /> {remote_only_text}
          </div>
        </div>
      </div>

      <div className={styles.clearAll} onClick={handleClearAll} title={clear_all_text}>
        <ClearAllIcon />
      </div>
    </div>
  );
};

export default FiltersInHeader;
